import React from 'react';
import { siteUrls } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';

function SupportSection(): React.JSX.Element {
    return (
        <p className="text-foreground mt-6 text-center text-base leading-relaxed">
            {`${UIStrings.StillHavingIssues} `}
            <a
                href={siteUrls.contactSupportUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary decoration-primary/40 hover:text-primary/90 font-medium underline underline-offset-2 transition-colors"
            >
                {UIStrings.ContactUsCapitalized}
            </a>
            {` ${UIStrings.ForAssistance}`}
        </p>
    );
}

export default SupportSection;
